<template>
  <div
    :class="
      options.namespace +
        '-base-container scroller-at-' +
        options.scroller_position
    "
  >
    <modal v-if="isModalVisible" @close="closeModal" :video="currentVideo" />
    <div
      ref="zoomerMainContainer"
      :class="resetImgClass"
      @click="openVideosModal(previewImage)"
      @keyup.enter="openVideosModal(previewImage)"
      tabindex="0"
    >
      <ProductBannerCopy />
      <img
        class="blank-image"
        alt="blank image"
        src="https://res.cloudinary.com/avd/image/upload/ar_1:1,w_528,c_fill,f_auto,q_auto/v1591548434/Others/white.png"
      />
      <img
        :src="
          previewImage.Url
            ? previewImage.Url
            : 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAQAAAAngNWGAAAAFElEQVR42mNkIBIwjiocVTiqEAQAJNYAFd868w4AAAAASUVORK5CYII='
        "
        :alt="previewImage.Title"
        :data-zoom="previewLargeImage.Url"
        class="responsive-image preview-box"
        draggable="false"
        :class="{ wideThumbnail: previewImage.VideoType }"
      />
      <overlay
        v-if="!previewImage.VideoId && !previewImage.version && showOverlay"
        class="imageTextOverlay"
      >
        Selected product options may not be accurately reflected in this image.
      </overlay>
      <span
        v-if="previewImage.VideoId || previewImage.version"
        class="playIcon"
        @click="openVideosModal(previewImage)"
      ></span>
      <div
        v-if="previewImage.VideoId || previewImage.version"
        class="thumbnailOverlay"
      ></div>
    </div>

    <p class="product-zoom-text roll-over-image">Roll over image to zoom</p>
    <p class="product-zoom-text tap-drag-image">Tap and drag image to zoom</p>
    <!-- Show Thumbnails list only if we have more than one image -->
    <div class="thumb-list" v-if="ThumbsImages.length > 1">
      <div
        ref="zoomerThumbnailContainer"
        class="zoomerThumbnailContainer"
        tabindex="0"
        @mouseover="chooseThumb(thumb, $event)"
        @click="chooseThumb(thumb, $event)"
        @keyup.enter="chooseThumb(thumb, $event)"
        @mouseout="chooseThumb(thumb, $event)"
        :key="key"
        v-for="(thumb, key) in ThumbsImages"
        v-bind:style="{
          border:
            thumb.id === choosedThumb.id
              ? '1px solid ' + options.choosed_thumb_border_color
              : '1px solid #ccc',
          boxShadow:
            thumb.id === choosedThumb.id
              ? '0 0 0 1px ' + options.choosed_thumb_border_color
              : ''
        }"
      >
        <div class="image-placeholder"></div>
        <img
          draggable="false"
          v-show="key < options.scroll_items"
          :alt="thumb.Title"
          :src="
            thumb.Url
              ? thumb.Url
              : 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAQAAAAngNWGAAAAFElEQVR42mNkIBIwjiocVTiqEAQAJNYAFd868w4AAAAASUVORK5CYII='
          "
          class="responsive-image"
          :class="{
            'choosed-thumb': thumb.id === choosedThumb.id,
            wideThumbnail: thumb.VideoType
          }"
        />
        <span
          v-if="thumb.VideoId || thumb.version"
          class="thumbnailPlayIcon"
        ></span>
      </div>
    </div>
    <div :id="pane_container_id" class="pane-container"></div>
  </div>
</template>

<script>
import Drift from "drift-zoom";
import modal from "./Modals/ProductDesktopVideosModal.vue";
import Overlay from "../shared/ImageTextOverlay";
import ProductBannerCopy from "./ProductBannerCopy";
import { mapGetters } from "vuex";

const actionName = s =>
  "scrollerAt" + (s.substr(0, 1).toUpperCase() + s.substr(1).toLowerCase());

export default {
  name: "ProductZoomer",
  props: {
    showOverlay: {
      type: Boolean,
      default: false
    },
    baseZoomerOptions: {
      type: Object,
      default: function() {
        return {};
      }
    },
    baseImages: {
      type: Object,
      required: true,
      default: function() {
        return {};
      }
    }
  },
  data() {
    return {
      previewImg: {},
      previewLargeImg: {},
      Thumbs: [],
      NormalSize: [],
      LargeSize: [],
      choosedThumb: {},
      drift: null,
      isModalVisible: false,
      currentVideo: {}
    };
  },
  components: {
    modal,
    Overlay,
    ProductBannerCopy
  },
  computed: {
    ...mapGetters("enhancedproduct", [
      "getResetToFirstImage",
      "getIsScreenSizeMobile"
    ]),
    options() {
      let defaultOptions = {
        zoomFactor: 4,
        pane: "container",
        hoverDelay: 0,
        namespace: "container-zoomer",
        move_by_click: true,
        scroll_items: this.baseImages.Thumbs.length,
        inlinePane: true,
        choosed_thumb_border_color: "#ff3d00",
        scroller_button_style: "line",
        scroller_position: "left",
        zoomer_pane_position: "right",
        onHide: () => {
          document
            .getElementById(this.pane_container_id)
            .classList.remove("pane-container-custom");
        },
        haveBeenUpdated: false
      };
      if (Object.keys(this.baseZoomerOptions).length > 0) {
        for (const key in this.baseZoomerOptions) {
          if (this.baseZoomerOptions.hasOwnProperty(key)) {
            const element = this.baseZoomerOptions[key];
            defaultOptions[key] = element;
          }
        }
      }
      return defaultOptions;
    },
    base_container_div: function() {
      return document.querySelector(
        "." + this.options.namespace + "-base-container"
      );
    },
    pane_container_id: function() {
      return this.options.namespace + "-pane-container";
    },
    preview_img: function() {
      return "." + this.options.namespace + "-base-container .preview-box";
    },
    ThumbsImages() {
      return this.baseImages.Thumbs;
    },
    NormalSizeImages() {
      return this.baseImages.NormalSize;
    },
    LargeSizeImages() {
      return this.baseImages.LargeSize;
    },
    zoomerImagesLength() {
      return this.baseImages.Thumbs.length;
    },
    previewLargeImage() {
      let matchLargeImg = this.LargeSizeImages.find(img => {
        return img.id === this.choosedThumb.id;
      });
      return matchLargeImg;
    },
    previewImage() {
      let matchNormalImg = this.NormalSizeImages.find(img => {
        return img.id === this.choosedThumb.id;
      });
      return matchNormalImg;
    },
    resetImgClass() {
      const resetImg = this.getResetToFirstImage ? "reset-img" : "";
      const mobileView = this.getIsScreenSizeMobile ? "moble-view" : "";
      return `zoomerMainContainer ${resetImg} ${mobileView}`;
    }
  },
  updated() {
    if (
      true === this.getResetToFirstImage &&
      false === this.getIsScreenSizeMobile
    ) {
      this.choosedThumb = this.Thumbs[0];
      this.$store.dispatch("enhancedproduct/resetToFirstImage", false);
    }
  },

  mounted() {
    if (
      !["left", "right", "top", "bottom"].includes(
        this.options.scroller_position
      )
    ) {
      throw "scroller_position is invalid";
    }
    if (!["fill", "line"].includes(this.options.scroller_button_style)) {
      throw "scroller_button_style is invalid";
    }
    if (!["left", "right"].includes(this.options.zoomer_pane_position)) {
      throw "zoomer_pane_position is invalid";
    }
    window.addEventListener("load", this.updateOptions);
    // in a fairly common edge case, load event listener doesn't register
    // so it checks options.haveBeenUpdated. if load is working updateOptions sets haveBeenUpdated to true
    // if it hasn't the check catches it and fires updateOptions
    if (false === this.options.haveBeenUpdated) {
      this.updateOptions();
    }
  },
  watch: {
    choosedThumb: function(thumb) {
      let matchNormalImg = this.NormalSizeImages.find(img => {
        return img.id === thumb.id;
      });
      let matchLargeImg = this.LargeSizeImages.find(img => {
        return img.id === thumb.id;
      });
      this.previewLargeImg = Object.assign({}, matchLargeImg);
      this.previewImg = Object.assign({}, matchNormalImg);
      if (this.drift !== null && matchLargeImg.url) {
        this.drift.setZoomImageURL(matchLargeImg.url);
      }
    }
  },
  destroyed() {
    window.removeEventListener("resize", this.zoomerMainContainerResize);
    window.removeEventListener("load", this.updateOptions);
  },
  created() {
    window.addEventListener("resize", this.zoomerMainContainerResize);
    if (Object.keys(this.baseImages).length > 0) {
      for (const key in this.baseImages) {
        if (this.baseImages.hasOwnProperty(key)) {
          this[key] = this.baseImages[key];
        }
      }
    }

    if (this.NormalSizeImages.length === 0) {
      throw "Product Zoomer Need Normal Size Image At Least!!!";
    }
    if (this.Thumbs.length === 0) {
      this.Thumbs = Object.assign([], this.NormalSizeImages);
    } else {
      this.choosedThumb = this.Thumbs[0];
    }
    if (this.LargeSizeImages.length === 0) {
      this.LargeSizeImages = Object.assign([], this.NormalSizeImages);
    }
    if (Object.keys(this.baseZoomerOptions).length > 0) {
      for (const key in this.baseZoomerOptions) {
        if (this.baseZoomerOptions.hasOwnProperty(key)) {
          const element = this.baseZoomerOptions[key];
          this.options[key] = element;
        }
      }
    }

    if (
      this.options.pane === "container-round" ||
      this.options.pane === "container"
    ) {
      this.options.hoverBoundingBox = false;
    } else {
      this.options.hoverBoundingBox = true;
    }
  },
  methods: {
    closeModal() {
      this.isModalVisible = false;
    },
    openVideosModal(previewImage) {
      if (previewImage.VideoUrl) {
        this.currentVideo = previewImage;
        this.isModalVisible = true;
      }
    },
    zoomerMainContainerResize() {
      if (
        this.$refs.zoomerMainContainer &&
        this.$refs.zoomerMainContainer.style &&
        this.$refs.zoomerMainContainer.style.height
      ) {
        this.$refs.zoomerMainContainer.style.height =
          this.$refs.zoomerMainContainer.clientWidth + 2 + "px";
      }

      if (
        this.$refs.zoomerThumbnailContainer &&
        this.$refs.zoomerThumbnailContainer.style &&
        this.$refs.zoomerThumbnailContainer.style.height
      ) {
        this.$refs.zoomerThumbnailContainer.style.height =
          this.$refs.zoomerThumbnailContainer.clientWidth + 2 + "px";
      }
    },
    chooseThumb(thumb, event) {
      let eventType = event.type;
      if (eventType === "mouseover") {
        this.tempThumb = this.choosedThumb;
        this.choosedThumb = thumb;
      } else if (eventType === "mouseout") {
        this.choosedThumb = this.tempThumb;
      } else {
        this.tempThumb = thumb;
        this.choosedThumb = thumb;
      }
    },
    scrollerAtBottom() {
      document
        .querySelector("." + this.options.namespace + "-base-container")
        .setAttribute("style", "position:relative;");
    },
    updateOptions() {
      this[actionName(this.options.scroller_position)]();

      this.options.injectBaseStyles = true;
      this.options.onShow = () => {
        document
          .getElementById(this.pane_container_id)
          .classList.add("pane-container-custom");
      };
      if (this.options.pane === "container-round") {
        this.options.inlinePane = true;
      } else {
        this.options.inlinePane = false;
        this.options.paneContainer = document.getElementById(
          this.pane_container_id
        );
        document
          .getElementById(this.pane_container_id)
          .classList.add("calculated-pane-position");
      }
      this.drift = new Drift(
        document.querySelector(this.preview_img),
        this.options
      );
      this.options.haveBeenUpdated = true;
    }
  }
};
</script>
<style>
@import "../../../node_modules/drift-zoom/src/css/drift-basic.css";
</style>

<style lang="scss" scoped>
.scroller-at-bottom .preview-box {
  cursor: pointer;
  width: 100%;
  position: absolute;
  left: 0;
  top: 0;
  background: #dddbdd
    url("https://res.cloudinary.com/avd/image/upload/v1588193793/ProductPage/placeholder-shimmer.gif")
    repeat-y center;
}

.not-ie .scroller-at-bottom .thumb-list {
  display: grid;
  @include media-breakpoint-down(md) {
    grid-template-columns: repeat(3, minmax(8rem, 1fr));
  }

  @include media-breakpoint-up(lg) {
    grid-template-columns: repeat(4, minmax(5rem, 1fr));
  }

  grid-auto-rows: 1fr;
  gap: 12px 15px;
  &::before {
    content: "";
    width: 0;
    padding-bottom: 100%;
    grid-row: 1 / 1;
    grid-column: 1 / 1;
  }

  > .zoomerThumbnailContainer {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-grow: 0;
    flex-shrink: 0;
    margin: 0 0 15px 0;
    box-sizing: border-box;
    object-fit: contain;
    @include media-breakpoint-down(md) {
      flex-basis: 33.333%;
    }

    > img {
      max-width: 100%;
      font-size: 12px;
    }
  }
}

.not-ie .scroller-at-bottom .thumb-list > *:first-child {
  grid-row: 1 / 1;
  grid-column: 1 / 1;
}

/* Just to make the grid visible */
.not-ie .scroller-at-bottom .thumb-list > * {
  border: 1px solid #ccc;
}

/* IE 11 */
.ie-11 .scroller-at-bottom .thumb-list {
  display: flex;
  flex-flow: row wrap;
  justify-content: flex-start;
  box-sizing: border-box;
  margin: 0 0 -10px -12px;
  width: calc(100% + 12px);

  .image-placeholder {
    display: block;
    background-color: #ffffff;

    @include media-breakpoint-down(md) {
      width: 95px;
      height: 95px;
    }

    @include media-breakpoint-up(xl) {
      width: 100px;
      height: 100px;
    }
  }

  > .zoomerThumbnailContainer {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-grow: 0;
    flex-shrink: 0;
    margin: 0 0 15px 12px;
    box-sizing: border-box;

    @include media-breakpoint-down(md) {
      flex-basis: calc(33.333% - 14px);
    }

    @include media-breakpoint-up(lg) {
      flex-basis: calc(25% - 14px);
    }

    > img {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
}

// Media queries added to provide height to wrapping container
// due to the absolute positioning of elements inside
@media screen and (max-width: 1024px) and (min-width: 950px) {
  .ie-11 .scroller-at-bottom .thumb-list .image-placeholder {
    height: 143px;
  }
}

@media screen and (max-width: 1150px) and (min-width: 1025px) {
  .ie-11 .scroller-at-bottom .thumb-list .image-placeholder {
    height: 35px;
  }
}

@media screen and (max-width: 1200px) and (min-width: 1150px) {
  .ie-11 .scroller-at-bottom .thumb-list .image-placeholder {
    height: 45px;
  }
}

@media screen and (max-width: 1400px) and (min-width: 1201px) {
  .ie-11 .scroller-at-bottom .thumb-list .image-placeholder {
    height: 55px;
  }
}

@media screen and (max-width: 1400px) and (min-width: 1301px) {
  .ie-11 .scroller-at-bottom .thumb-list .image-placeholder {
    height: 60px;
  }
}

@media screen and (max-width: 1600px) and (min-width: 1401px) {
  .ie-11 .scroller-at-bottom .thumb-list .image-placeholder {
    height: 70px;
  }
}

@media (max-width: 1800px) and (min-width: 1601px) {
  .ie-11 .scroller-at-bottom .thumb-list .image-placeholder {
    height: 80px;
  }
}

.scroller-at-top .thumb-list .responsive-image,
.ie-11 .scroller-at-bottom .thumb-list .responsive-image {
  max-width: 100%;
  background: #dddbdd
    url("https://res.cloudinary.com/avd/image/upload/v1588193793/ProductPage/placeholder-shimmer.gif")
    repeat-y center;
}

.zoomer-control {
  cursor: pointer;
}
.choosed-thumb {
  border-radius: 0px;
}
.pane-container {
  position: absolute;
  z-index: 10;
  pointer-events: none;
}
.product-zoom-text {
  color: #666766;
  font-size: 12px;
  line-height: 20px;
  letter-spacing: 0.75px;
  margin: 5px 0 20px 0;
}

.pane-container-custom {
  box-shadow: 0px 3px 8px 0px rgba(0, 0, 0, 0.4) !important;
}

.calculated-pane-position {
  left: 100%;
  display: none;
  top: 0px;
  margin-left: 20px;

  @include media-breakpoint-up(md) {
    width: 358px;
    height: 358px;
    display: block;
  }

  @include media-breakpoint-up(lg) {
    width: 568px;
    height: 568px;
    display: block;
  }
}

.roll-over-image {
  display: none;
  @include media-breakpoint-up(md) {
    display: none;
  }

  @include media-breakpoint-up(lg) {
    display: block;
  }
}

::v-deep .drift-zoom-pane {
  display: none !important;
  background-color: transparent !important;
}

::v-deep .drift-zoom-pane.drift-open {
  display: block !important;
  background-color: #dddbdd !important;
}

.tap-drag-image {
  display: none;
  @include media-breakpoint-up(md) {
    display: block;
  }

  @include media-breakpoint-up(lg) {
    display: none;
  }
}

.playIcon {
  color: $aqua;
  transform: translate(-50%, -50%);
  font-size: 70px;
  position: absolute;
  left: 50%;
  top: 50%;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='130' height='130' viewBox='0 0 130 130'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath fill='%23000' fill-opacity='.5' d='M65,0 C29.12,0 0,29.12 0,65 C0,100.88 29.12,130 65,130 C100.88,130 130,100.88 130,65 C130,29.12 100.88,0 65,0 Z'/%3E%3Cpolygon fill='%23FFF' points='52 94.25 91 65 52 35.75'/%3E%3C/g%3E%3C/svg%3E%0A");
  width: 30%;
  height: 30%;
  background-repeat: no-repeat;
  background-size: 97%;
  cursor: pointer;
  z-index: 10;

  &:hover {
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='130' height='130' viewBox='0 0 130 130'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath fill='%2325C0D0' stroke='%23FFF' d='M65,0.5 C47.198,0.5 31.0730397,7.72406706 19.3985534,19.3985534 C7.72406706,31.0730397 0.5,47.198 0.5,65 C0.5,82.802 7.72406706,98.9269603 19.3985534,110.601447 C31.0730397,122.275933 47.198,129.5 65,129.5 C82.802,129.5 98.9269603,122.275933 110.601447,110.601447 C122.275933,98.9269603 129.5,82.802 129.5,65 C129.5,47.198 122.275933,31.0730397 110.601447,19.3985534 C98.9269603,7.72406706 82.802,0.5 65,0.5 Z'/%3E%3Cpolygon fill='%23FFF' points='52 94.25 91 65 52 35.75'/%3E%3C/g%3E%3C/svg%3E%0A");
  }
}

.thumbnailPlayIcon {
  color: $aqua;
  transform: translate(-50%, -50%);
  position: absolute;
  left: 50%;
  top: 50%;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='130' height='130' viewBox='0 0 130 130'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath fill='%23000' fill-opacity='.5' d='M65,0 C29.12,0 0,29.12 0,65 C0,100.88 29.12,130 65,130 C100.88,130 130,100.88 130,65 C130,29.12 100.88,0 65,0 Z'/%3E%3Cpolygon fill='%23FFF' points='52 94.25 91 65 52 35.75'/%3E%3C/g%3E%3C/svg%3E%0A");
  width: 1.75em;
  height: 1.75em;
  background-repeat: no-repeat;
  background-size: 97%;
  cursor: pointer;
  z-index: 10;

  &:hover {
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='130' height='130' viewBox='0 0 130 130'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath fill='%2325C0D0' stroke='%23FFF' d='M65,0.5 C47.198,0.5 31.0730397,7.72406706 19.3985534,19.3985534 C7.72406706,31.0730397 0.5,47.198 0.5,65 C0.5,82.802 7.72406706,98.9269603 19.3985534,110.601447 C31.0730397,122.275933 47.198,129.5 65,129.5 C82.802,129.5 98.9269603,122.275933 110.601447,110.601447 C122.275933,98.9269603 129.5,82.802 129.5,65 C129.5,47.198 122.275933,31.0730397 110.601447,19.3985534 C98.9269603,7.72406706 82.802,0.5 65,0.5 Z'/%3E%3Cpolygon fill='%23FFF' points='52 94.25 91 65 52 35.75'/%3E%3C/g%3E%3C/svg%3E%0A");
  }
}

.zoomerMainContainer {
  position: relative;
  border: 1px solid #ccc;
  cursor: pointer;
  &:hover {
    .playIcon {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='130' height='130' viewBox='0 0 130 130'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath fill='%2325C0D0' stroke='%23FFF' d='M65,0.5 C47.198,0.5 31.0730397,7.72406706 19.3985534,19.3985534 C7.72406706,31.0730397 0.5,47.198 0.5,65 C0.5,82.802 7.72406706,98.9269603 19.3985534,110.601447 C31.0730397,122.275933 47.198,129.5 65,129.5 C82.802,129.5 98.9269603,122.275933 110.601447,110.601447 C122.275933,98.9269603 129.5,82.802 129.5,65 C129.5,47.198 122.275933,31.0730397 110.601447,19.3985534 C98.9269603,7.72406706 82.802,0.5 65,0.5 Z'/%3E%3Cpolygon fill='%23FFF' points='52 94.25 91 65 52 35.75'/%3E%3C/g%3E%3C/svg%3E%0A");
    }
  }

  &:focus {
    @include focus_outline();
  }
}

.thumbnailOverlay {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  z-index: 9;
}

.preview-box.wideThumbnail {
  transform: translate(-50%, -50%) !important;
  position: absolute !important;
  left: 50% !important;
  top: 50% !important;
}

.zoomerThumbnailContainer {
  position: relative;
  border: 1px solid #ccc;
  overflow: hidden;
  &:hover {
    .thumbnailPlayIcon {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='130' height='130' viewBox='0 0 130 130'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath fill='%2325C0D0' stroke='%23FFF' d='M65,0.5 C47.198,0.5 31.0730397,7.72406706 19.3985534,19.3985534 C7.72406706,31.0730397 0.5,47.198 0.5,65 C0.5,82.802 7.72406706,98.9269603 19.3985534,110.601447 C31.0730397,122.275933 47.198,129.5 65,129.5 C82.802,129.5 98.9269603,122.275933 110.601447,110.601447 C122.275933,98.9269603 129.5,82.802 129.5,65 C129.5,47.198 122.275933,31.0730397 110.601447,19.3985534 C98.9269603,7.72406706 82.802,0.5 65,0.5 Z'/%3E%3Cpolygon fill='%23FFF' points='52 94.25 91 65 52 35.75'/%3E%3C/g%3E%3C/svg%3E%0A");
    }
  }

  &:focus {
    @include focus_outline-alt();
  }
}

.blank-image {
  width: 100%;
}
.imageTextOverlay {
  width: 100%;
  padding: 0 16px;
  @include media-breakpoint-up(md) {
    bottom: 12px;
  }
}
</style>
